import { all, fork } from 'redux-saga/effects'
import commonSagaRoot from 'x/redux/commonSagaRoot'

/**
 * Root saga manages watcher lifecycle
 */
export default function* rootSaga() {
  yield all([fork(commonSagaRoot)])
}
